import { default as BasicTable } from "./basic/BasicTable.vue";
import { default as FilterableOverviewTable } from "./basic/FilterableOverviewTable.vue";
import { default as OverviewTable } from "./basic/OverviewTable.vue";
import { default as PlainTable } from "./basic/PlainTable.vue";
import { default as ReportTable } from "./basic/ReportTable.vue";
import { default as SimpleTable } from "./basic/SimpleTable.vue";
import { default as InvoiceItemTable } from "./specific/InvoiceItemTable.vue";
import { default as ProvisionSpecTable } from "./specific/ProvisionSpecTable.vue";

export const Table = {
    Basic: BasicTable,
    FilterableOverview: FilterableOverviewTable,
    InvoiceItem: InvoiceItemTable,
    Overview: OverviewTable,
    Plain: PlainTable,
    Report: ReportTable,
    ProvisionSpec: ProvisionSpecTable,
    Simple: SimpleTable,
};

export { defineTable, defineTableSource, type TableRequest } from "./common";
